import {
  getGradingCommentTemplatesField,
  getLearningCourseField,
} from "./modules/utils";

const IbDpCurriculumProgramPolicy = {
  IbDpCurriculumProgram: {
    fields: {
      gradingCommentTemplates: getGradingCommentTemplatesField(),
      learningCourse: getLearningCourseField(),
    },
  },
};

export default IbDpCurriculumProgramPolicy;
